export const withTimeout = <P extends unknown[], R>(
  asyncFunction: (...args: P) => Promise<R>,
  timeout: number
): ((...args: P) => Promise<R | void>) => {
  let clearThis: number = 0

  const timeoutRejection = (): Promise<void> =>
    new Promise((_resolve, reject) => {
      clearThis = window.setTimeout(() => {
        reject('Timeout')
      }, timeout)
    })

  const run = async (...args: P): Promise<R | void> => {
    try {
      const result = await Promise.race([
        timeoutRejection(),
        asyncFunction(...args),
      ])
      return result
    } finally {
      if (clearThis) {
        window.clearTimeout(clearThis)
      }
    }
  }

  return run
}
